<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { normalizeKanbanAccess } from 'dashboard/helper/kanbanSharedAccess';

const props = defineProps({
  access: {
    type: Object,
    default: null,
  },
});

const { t } = useI18n();
const normalizedAccess = computed(() => normalizeKanbanAccess(props.access));
const levelLabel = computed(() => {
  if (normalizedAccess.value.level === 'edit') {
    return t('KANBAN_SHARING.LEVELS.EDIT');
  }
  if (normalizedAccess.value.level === 'comment') {
    return t('KANBAN_SHARING.LEVELS.COMMENT');
  }
  return t('KANBAN_SHARING.LEVELS.VIEW');
});

const recipientDescription = computed(() => {
  if (normalizedAccess.value.level === 'edit') {
    return t('KANBAN_SHARING.RECIPIENT.EDIT');
  }
  if (normalizedAccess.value.level === 'comment') {
    return t('KANBAN_SHARING.RECIPIENT.COMMENT');
  }
  return t('KANBAN_SHARING.RECIPIENT.VIEW');
});
</script>

<template>
  <div
    v-show="normalizedAccess.shared"
    data-testid="kanban-shared-access-banner"
    class="rounded-xl border border-n-weak bg-n-alpha-2 px-3 py-2.5"
    role="status"
  >
    <div class="flex items-center gap-2 text-sm font-medium text-n-slate-12">
      <span class="i-ph-lock-key size-4 text-n-blue-11" />
      {{ levelLabel }}
    </div>
    <p class="mb-0 mt-1 text-xs leading-5 text-n-slate-11">
      {{ recipientDescription }}
    </p>
    <p class="mb-0 mt-1 text-xs text-n-slate-11">
      {{ t('KANBAN_SHARING.RECIPIENT.CONVERSATION_RESTRICTED') }}
    </p>
  </div>
</template>
